export const SITE_URL = "https://horns.se";

// Per-segment SEO metadata (grounded only in existing site facts). Keyed by collection id.
export const SEGMENT_SEO = {
  "production-tools": {
    sv: {
      title: "Produktionsverktyg & produktionsutrustning | Horns Industriservice",
      description:
        "Kundanpassade produktionsverktyg och produktionsutrustning konstruerade och tillverkade in-house. Från koncept och CAD/CAM till CNC-bearbetning och färdig produktionslösning.",
      keywords: "produktionsverktyg, produktionsutrustning, produktionsfixtur, fixturkonstruktion, precisionstillverkning",
    },
    en: {
      title: "Production Tooling & Equipment | Horns Industriservice",
      description:
        "Custom production tooling and equipment designed and manufactured in-house — from concept and CAD/CAM to CNC machining and a finished production solution.",
      keywords: "production tooling, production equipment, production fixtures, fixture design, precision manufacturing",
    },
  },
  machines: {
    sv: {
      title: "Bearbetningsfixturer & CNC-fixturer | Horns Industriservice",
      description:
        "Bearbetningsfixturer och CNC-fixturer för krävande produktion. Vi konstruerar och tillverkar kundanpassade fixturer för CNC-bearbetning med hög repeterbarhet och precision.",
      keywords: "bearbetningsfixturer, CNC-fixtur, hydraulisk bearbetningsfixtur, fixturkonstruktion, maskinpalett, produktionsfixtur, fixturer för CNC-bearbetning",
    },
    en: {
      title: "Machining Fixtures & CNC Fixtures | Horns Industriservice",
      description:
        "Machining and CNC fixtures for demanding production. We design and manufacture custom fixtures for CNC machining with high repeatability and precision.",
      keywords: "machining fixtures, CNC fixture, hydraulic machining fixture, fixture design, machine pallet, production fixture",
    },
  },
  "defense-components": {
    sv: {
      title: "Underleverantör till svensk försvarsindustri | Horns Industriservice",
      description:
        "Kontrakts- och komponenttillverkning för svensk försvarsindustri. Precisionskomponenter och CNC-bearbetning med spårbarhet och dokumentation, konstruktion och tillverkning in-house.",
      keywords: "försvarsindustri, underleverantör försvarsindustri, kontraktstillverkning försvar, CNC försvarsindustri, precisionskomponenter försvar, mekanisk tillverkning försvar, svensk tillverkning försvarsindustri",
    },
    en: {
      title: "Subcontractor to the Swedish Defence Industry | Horns Industriservice",
      description:
        "Contract and component manufacturing for the Swedish defence industry. Precision components and CNC machining with traceability and documentation — design and production in-house.",
      keywords: "defence industry, defence subcontractor, contract manufacturing defence, CNC defence, precision components defence, Swedish defence manufacturing",
    },
  },
  "hydraulic-solutions": {
    sv: {
      title: "Hydraulpressar & hydrauliska lösningar | Horns Industriservice",
      description:
        "Hydraulpressar och hydrauliska lösningar för produktion och automation. Kundanpassad konstruktion och tillverkning in-house för krävande industriella tillämpningar.",
      keywords: "hydraulpress, hydraulisk fixtur, hydraullösningar, hydraulik, hydraulcylinder, specialmaskin",
    },
    en: {
      title: "Hydraulic Presses & Hydraulic Solutions | Horns Industriservice",
      description:
        "Hydraulic presses and hydraulic solutions for production and automation. Custom design and in-house manufacturing for demanding industrial applications.",
      keywords: "hydraulic press, hydraulic fixture, hydraulic solutions, hydraulics, hydraulic cylinder, special machine",
    },
  },
  "robots-accessories": {
    sv: {
      title: "Robotgripdon, robotfixturer & automationsutrustning | Horns Industriservice",
      description:
        "Robotgripdon, robotfixturer och automationsutrustning. Vi konstruerar och bygger kundanpassade automationslösningar och specialmaskiner in-house för svensk industri.",
      keywords: "robotgripdon, robotfixturer, gripdon, automationsutrustning, industriautomation, automationslösningar, specialmaskin, robotcell",
    },
    en: {
      title: "Robot Grippers, Robot Fixtures & Automation Equipment | Horns Industriservice",
      description:
        "Robot grippers, robot fixtures and automation equipment. We design and build custom automation solutions and special machines in-house for Swedish industry.",
      keywords: "robot grippers, robot fixtures, gripper, automation equipment, industrial automation, automation solutions, special machine, robot cell",
    },
  },
  verification: {
    sv: {
      title: "Kontrollfixturer & mätfixturer | Horns Industriservice",
      description:
        "Kontrollfixturer och mätfixturer för kvalitetssäkring i produktion. Kundanpassad konstruktion för verifiering, mätning och repeterbar kvalitetskontroll.",
      keywords: "kontrollfixtur, mätfixtur, verifiering, kvalitetskontroll, mätning, precisionsverifiering",
    },
    en: {
      title: "Inspection Fixtures & Gauging Fixtures | Horns Industriservice",
      description:
        "Inspection and gauging fixtures for quality assurance in production. Custom design for verification, measurement and repeatable quality control.",
      keywords: "inspection fixture, gauging fixture, verification, quality control, measurement, precision verification",
    },
  },
};

export const HOME_SEO = {
  sv: {
    title: "Horns Industriservice AB | Bearbetningsfixturer, automation & precisionstillverkning",
    description:
      "Avancerad svensk teknik- och tillverkningspartner. Vi konstruerar och tillverkar bearbetningsfixturer, produktionsverktyg, automationsutrustning och precisionskomponenter — in-house, med CAD/CAM och CNC. ISO 9001 & ISO 14001.",
    keywords: "bearbetningsfixturer, produktionsverktyg, automationsutrustning, industriautomation, kontraktstillverkning, precisionstillverkning, CNC-bearbetning, försvarsindustri",
  },
  en: {
    title: "Horns Industriservice AB | Machining Fixtures, Automation & Precision Manufacturing",
    description:
      "Advanced Swedish engineering and manufacturing partner. We design and manufacture machining fixtures, production tooling, automation equipment and precision components — in-house, with CAD/CAM and CNC. ISO 9001 & ISO 14001.",
    keywords: "machining fixtures, production tooling, automation equipment, industrial automation, contract manufacturing, precision manufacturing, CNC machining, defence industry",
  },
};

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Horns Industriservice AB",
  url: SITE_URL,
  logo: `${SITE_URL}/horns-logo.png`,
  foundingDate: "1985",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kisa",
    addressRegion: "Östergötland",
    addressCountry: "SE",
  },
  areaServed: "SE",
  email: "info@horns.se",
};
